import React from "react";
import {withStyles} from '@material-ui/core/styles';

const ToolbarSpacer = ({classes}) => (
    <div className={classes.space}></div>
);

const styles = theme => ({
    space: {
        position: 'relative',
        width: '100%',
    },
});

export default withStyles(styles)(ToolbarSpacer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Toolbar/Spacer.jsx